<template>
  <div
    class="dropdown br-dropdown"
    v-bind:data-ri-filtername="filterName"
    data-ri-filtervalue="this .selectedTitle"
    data-ri-force="true"
  >
    <label class="form-label" data-tool-tip="true">
      <info-icon></info-icon>
    </label>
    <p
      class="dropdown__selected selected selectedTitle +mg-bottom-none"
      v-bind:class="{ '--is-active': isExpanded, '--disabled': disabled }"
      v-on:click.stop="toggleAction()"
    >
      {{ selectedText }}
      <svg
        class="dropdown__arrow"
        width="13px"
        height="13px"
        viewBox="0 0 13 13"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill=""
          fill-rule="evenodd"
        >
          <g id="Icons" transform="translate(-340.000000, -38.000000)" fill="">
            <g
              id="dropdown-arrow-inactive"
              transform="translate(340.000000, 38.000000)"
            >
              <path
                d="M6.86396103,10.9497475 L6.86396103,0 L5.86396103,0 L5.86396103,10.9497475 L0.707106781,5.79289322 L0,6.5 L6.36396103,12.863961 L6.71751442,12.5104076 L12.7279221,6.5 L12.0208153,5.79289322 L6.86396103,10.9497475 Z"
                id="Combined-Shape"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </p>
    <div
      class="dropdown__list-wrapper br-dropdown-container"
      v-show="isExpanded"
    >
      <div class="dropdown__list-container">
        <ul class="list-bare +mg-none">
          <li
            class="dropdown__list-item"
            :class="isSelectedItem(item) ? 'selected' : ''"
            v-for="(item, index) in options"
            :key="index"
            @click.stop="changeAction(item)"
          >
            <span class="dropdown__radio"></span>
            <span class="dropdown__input-label">{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import eventHub from '../bankrate-events/index'
import utility from '../../bankrate-utilities/index'
import infoIcon from './rt-info.vue'

// @DEPRECATED - Rewrite or clean up for any future use
export default {
  components: {
    'info-icon': infoIcon
  },

  props: {
    // General settings for the component
    settings: {
      default: function() {
        return {
          uniqueId: '',
          title: ''
        }
      }
    },

    // Options
    options: {
      default: function() {
        return []
      }
    },

    defaultSelected: {
      default: ''
    },

    // Title to be sent to DataCollector
    filterTitle: {
      default: ''
    },

    // The tooltip data
    copy: {
      default: function() {
        return []
      }
    },

    disabled: {
      default: function() {
        return false
      }
    }
  },

  data: function() {
    return {
      // The status of the drop-down
      isExpanded: false,
      selected: ''
    }
  },

  computed: {
    /**
     * Verify if are a single element selected
     *
     * @returns {String}
     */

    selectedText: function() {
      if (this.selected !== '') {
        let single = utility.arrayObjectIndexOf(
          this.options,
          'value',
          this.selected
        )

        return single.item ? single.item.name : ''
      }
      return ''
    },

    /**
     * Return string acceptable for dataCollector
     */
    filterName: function() {
      return utility.dataCollectorFormat(
        (this.filterTitle
          ? this.filterTitle
          : this.settings.title
        ).toLowerCase()
      )
    }
  },

  created: function() {
    this.selected = this.defaultSelected
    /**
     * Listening Events
     *
     */
    eventHub.$on('dropDown::close', this.closeEvent)
    if (
      this.settings.uniqueId === 'depositType' ||
      this.settings.uniqueId === 'loanType'
    ) {
      eventHub.$emit('rateTable::setDepositType', this.selectedText)
    }
  },

  methods: {
    /**
     * Verifies if the current element is selected
     * @param item
     */
    isSelectedItem: function(item) {
      // TODO: implement this using lodash or a handmade solution
      if (typeof this.selected === 'string') {
        return this.selected === item.value
      } else {
        return JSON.stringify(this.selected) === JSON.stringify(item.value)
      }
    },

    /**
     * Process the close event
     */

    closeEvent: function() {
      if (this.isExpanded) {
        this.isExpanded = false
      }
    },

    /**
     * Toggle drop-down show/hide state
     */
    toggleAction: function() {
      if (this.disabled) {
        return
      }

      if (this.isExpanded === true) {
        this.isExpanded = false
      } else {
        eventHub.$emit('dropDown::close')
        this.isExpanded = true
      }
    },

    /**
     * Main action (drop-down change for options click)
     * The event emitted by this component is always dropDownChange
     * The data sent with the event is an object like:
     * {name: the_unique_identifier_of_this_component, item: the_value_for_this_item}
     *
     * @param item
     * @returns {void}
     */

    changeAction: function(item) {
      if (this.selected !== item.value) {
        this.selected = item.value
        this.notifyChanges()
      }
      if (
        this.settings.uniqueId === 'depositType' ||
        this.settings.uniqueId === 'loanType'
      ) {
        eventHub.$emit('rateTable::setDepositType', this.selectedText)
      }
      this.toggleAction()
    },

    notifyChanges: function() {
      eventHub.$emit('dropDown::change', {
        uniqueId: this.settings.uniqueId,
        selected: this.selected
      })
    }
  }
}
</script>
